export const CONTRIBUTION_TYPE_FLAT = {
    label: 'Flat',
    _id: '507f1f07bcf96cd792445013',
    description: 'External user is paid for activity on a per hour basis',
};
export const CONTRIBUTION_TYPE_REIMBURSEMENT = {
    label: 'Reimbursement/Stipend',
    _id: '507f1f17bcf36cd799249113',
    description: 'External user is reimbursed or receives stipend for activity',
};
export const CONTRIBUTION_TYPE_SALARIED_HOURLY = {
    label: 'Salaried/Hourly',
    _id: '502f1f17bcf56ce799477013',
    description: 'Staff user is paid (salary or wage) for activity',
};
export const CONTRIBUTION_TYPE_DONATED_TIME = {
    label: 'Donated Time',
    _id: '517f1f17bcf56cd790418013',
    description: 'External or staff user provides service without charge',
};
export const CONTRIBUTION_TYPE_HOURLY = {
    label: 'Hourly',
    _id: '507f9f79bcf96cd399241013',
    description: 'External user is paid for activity on a per hour basis',
};

export const USER_STAFF_RATE_TYPES = [CONTRIBUTION_TYPE_DONATED_TIME, CONTRIBUTION_TYPE_SALARIED_HOURLY];

export const USER_EXTERNAL_CONTRIBUTION_TYPE = [
    CONTRIBUTION_TYPE_HOURLY,
    CONTRIBUTION_TYPE_FLAT,
    CONTRIBUTION_TYPE_REIMBURSEMENT,
    CONTRIBUTION_TYPE_DONATED_TIME,
];
